import { Options as ClickTrackingOptions } from 'js/utils/trackClick';

export type AutotestStamp = {
  autotest?: string;
  autotest_bucket: string;
  // modal_version = the layout at open (paper_card|default),
  modal_version?: string;
  // render_state = rendered-vs-fallback (content arms),
  render_state?: string;
  // memory_state = memory ladder rung
  memory_state?: string;
};

// Api::V0::ClicksController rejects the whole click when the extra JSON
// (keys + values + punctuation) is 256+ chars, so shed aux keys (least
// analysis-critical first) to stay under.
const EXTRA_JSON_BUDGET = 255;
const AUX_DROP_ORDER: ReadonlyArray<keyof AutotestStamp> = [
  'memory_state',
  'render_state',
  'modal_version',
];

export function stampedExtra(
  baseExtra: object | undefined,
  stamp: AutotestStamp,
): object {
  const merged: Record<string, unknown> = { ...baseExtra, ...stamp };
  for (const auxKey of AUX_DROP_ORDER) {
    if (JSON.stringify(merged).length <= EXTRA_JSON_BUDGET) break;
    delete merged[auxKey];
  }
  if (JSON.stringify(merged).length > EXTRA_JSON_BUDGET) {
    return { ...baseExtra };
  }
  return merged;
}

export function stampTrackingContext(
  context: Partial<ClickTrackingOptions> | undefined,
  stamp: AutotestStamp,
): Partial<ClickTrackingOptions> {
  return { ...context, extra: stampedExtra(context?.extra, stamp) };
}
